<template>
  <tr
    ref="trEl"
    class="qtl-row"
    :class="{ 'qtl-row--checked': isChecked, 'qtl-row--even': rowIndex % 2 === 1 }"
    :data-entity-id="row.entityId"
    :data-index="dataIndex"
  >
    <QTLiteRowCells
      :row="row"
      :row-index="rowIndex"
      :row-number-base="rowNumberBase"
      :columns="columns"
      :src-element="srcElement"
      :WA="WA"
      :is-checked="isChecked"
      @toggleCheckbox="$emit('toggleCheckbox', $event)"
      @changeHoverRecord="$emit('changeHoverRecord', $event)"
      @changeHeights="$emit('changeHeights', $event)"
      @refreshNeeded="$emit('refreshNeeded')"
      @updatePerson="$emit('updatePerson', $event)"
      @updateSelection="$emit('updateSelection', $event)"
      @checkBoxClick="$emit('checkBoxClick')"
      @sourceItemsRequested="$emit('sourceItemsRequested', $event)"
    />
  </tr>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import QTLiteRowCells from "./QTLiteRowCells.vue";
import { useRowParameterHeights } from "../composables/useRowParameterHeights";
import type { LiteColumn, LiteRow } from "../types";

const props = defineProps<{
  row: LiteRow;
  columns: LiteColumn[];
  srcElement: any;
  WA: boolean;
  isChecked: boolean;
  rowIndex: number;
  /** номер первой строки страницы (= pagination offset), для сквозной нумерации */
  rowNumberBase?: number;
  widthStamp?: string;
  /** индекс строки в виртуализаторе; нужен measureElement (@tanstack/vue-virtual) */
  dataIndex?: number;
}>();

defineEmits<{
  (e: "toggleCheckbox", payload: { entityId: number; checked: boolean }): void;
  (e: "changeHoverRecord", payload: any): void;
  (e: "changeHeights", payload: any): void;
  (e: "refreshNeeded"): void;
  (e: "updatePerson", payload: { ev: any; entityId: number }): void;
  (e: "updateSelection", payload: { entityId: number; checked: boolean }): void;
  (e: "checkBoxClick"): void;
  (e: "sourceItemsRequested", payload: { ids: number[]; type: number; entityId: number }): void;
}>();

const trEl = ref<HTMLTableRowElement | null>(null);
const widthsFingerprint = computed(() => `${props.columns.map((c) => c.id).join("|")}::${props.widthStamp || ""}`);
const alignmentEnabled = computed<boolean>(() => !!props.row.hasParameterAlignment);
useRowParameterHeights({ rowEl: trEl, enabled: alignmentEnabled, trigger: widthsFingerprint });

// корневой <tr> нужен QTLiteBody, чтобы отдать строку виртуализатору на замер высоты
defineExpose({ get rootEl() { return trEl.value; } });
</script>

<style lang="scss" scoped>
.qtl-row {
  contain: layout style paint;
  background: #fff;
  color: #333333;
  font-size: 12px;
}

.qtl-row--even {
  background: #f9f9f9;
}

.qtl-row:hover,
.qtl-row--even:hover {
  background: #f2f2f2;
}

.qtl-row--checked {
  background-color: #f3f8f4;
}
</style>
